/**
 * Product Carousel — tab switching logic.
 * Swiper init is handled by the shared carousel.js (via js_carousel__swiper);
 * this script only manages tab panel visibility and lazy-inits hidden swipers.
 */
import { initSwiper } from './carousel.js';

// Tab switching
document.querySelectorAll('[data-carousel-tab]').forEach(function (tabLink) {
    tabLink.addEventListener('click', function (e) {
        e.preventDefault();

        const targetId = this.dataset.carouselTab;
        const section = this.closest('.js_product_carousel');
        if (!section) {
            return;
        }

        const targetPanel = section.querySelector('#' + targetId)?.closest('.js_product_carousel__tab_panel');
        if (!targetPanel) {
            return;
        }

        // Update tab active states
        section.querySelectorAll('[data-carousel-tab]').forEach(function (tab) {
            tab.classList.remove('category_switch__item--active', 'js_category_switch__item--active');
            tab.removeAttribute('aria-current');
        });
        this.classList.add('category_switch__item--active', 'js_category_switch__item--active');
        this.setAttribute('aria-current', 'true');

        // Switch tab panel visibility
        section.querySelectorAll('.js_product_carousel__tab_panel').forEach(function (panel) {
            panel.classList.add('product_carousel__tab_panel--hidden');
        });
        targetPanel.classList.remove('product_carousel__tab_panel--hidden');

        // Lazy-init swiper if not yet done
        const swiperEl = targetPanel.querySelector('.js_carousel__swiper');
        if (swiperEl && !swiperEl.swiper) {
            initSwiper(swiperEl);
        }
    });
});
